import React, { Component, Suspense } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import { Row, CardBody } from 'reactstrap';
import {
  AppFooter,
  AppHeader,
} from '@coreui/react';
import routes from '../../routes';
import '../../scss/empty_layout.scss';
import '../../scss/csm.scss';
const DefaultAgilitytHeader = React.lazy(() => import('./DefaultAgilitytHeader'));
const DefaultMobileAgility = React.lazy(() => import('./DefaultMobileAgility'));
class AgilityThinkingLayout extends Component {

  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>;

  loadingText = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>;

  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };
  }
  componentDidMount() {
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 980;

    if(isMobile){
      return (
        <div className="app">
          <Suspense fallback={this.loadingText()} >
            <CardBody className="fixed-alert-box" id="fixed-error-div">

            </CardBody>
            <AppHeader fixed style={{height: '0px'}}>
              <Suspense>
                <DefaultMobileAgility/>
              </Suspense>
            </AppHeader>
            <div className="app-body">

              <main className="main">
                <Container fluid>
                  <Suspense>
                    <Switch>
                      {routes.map((route, idx) => {
                        return route.component ? (
                          <Route
                            key={idx}
                            path={route.path}
                            exact={route.exact}
                            name={route.name}
                            render={props => (
                              <route.component {...props} />
                            )} />
                        ) : (null);
                      })}
                    </Switch>
                  </Suspense>
                </Container>
              </main>

            </div>

          </Suspense>
        </div>
      );
    }else{
      return (
        <div className="app">
          <CardBody className="fixed-alert-box" id="fixed-error-div">

          </CardBody>
          <AppHeader fixed style={{height: '0px'}}>
            <Suspense  fallback={this.loading()}>
              <DefaultAgilitytHeader/>
            </Suspense>
          </AppHeader>
          <div className="app-body">
            <Container fluid>
              <Suspense fallback={this.loading()}>

                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={props => (
                          <route.component {...props} />
                        )} />
                    ) : (null);
                  })}

                </Switch>
              </Suspense>
            </Container>
          </div>
        </div>
      );
    }
  }
}

export default withRouter(AgilityThinkingLayout);
